import { render, staticRenderFns } from "./rodo.page.vue?vue&type=template&id=64e2a363&scoped=true&"
import script from "./rodo.page.vue?vue&type=script&lang=js&"
export * from "./rodo.page.vue?vue&type=script&lang=js&"
import style0 from "./rodo.page.vue?vue&type=style&index=0&id=64e2a363&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e2a363",
  null
  
)

export default component.exports